// data.js
import shop from "../../asset/shop.jpg";
import shop2 from "../../asset/shop2.png";
import courier from "../../asset/courier.jpg";
import play from "../../asset/play.jpg";
import game from "../../asset/game.jpg";
import gamead from "../../asset/gamead.jpg";
import geegpay from "../../asset/geegpay.png";
import shopfinity from "../../asset/shopfinity.png";
import thriller from "../../asset/thriller.png";
import mernstore from "../../asset/mernstore.png";
import poqe from "../../asset/poqe.png";
import votersHq from "../../asset/votershq.png";
import osyr24 from "../../asset/osyr24.png";
import edquity from "../../asset/edquity.png";
import mintly from "../../asset/mintly.png";
import outsidelab from "../../asset/outsidelab.png";
import stablestack from "../../asset/stablestack.png";
import stabledoc from "../../asset/stabledoc.png";
import realestate from "../../asset/realestate.png";
import opportuniverse from "../../asset/opportuniverse.png";
import mozofy from "../../asset/mozofy.png";
import abbas from "../../asset/abbas.png";
import builditlab from "../../asset/builditlab.png";
import henosis from "../../asset/henosis.png";
import wale_lab from "../../asset/wale_lab.png";
import marketverse from "../../asset/marketverse.png";
import playstoreApps from "../../asset/playstore.png";


export const portfolioData = [
  {
    id: 27, // use the next free id
    image: playstoreApps,
    title: "Android Games on Google Play",
    description:
      "Puzzle Mayan, Tiki Blast, Puzzle Block Wild and more, published under MV Marketplace Technologies.",
    demo: "https://play.google.com/store/apps/developer?id=MV+Marketplace+Technologies",
    cta: "View on Play Store",
  },
  {
    id: 26,
    image: marketverse,
    title: "MarketVerse",
    description:
      "A multi-vendor marketplace platform built with NestJS, Prisma, and PostgreSQL on the backend and React/TypeScript with Tailwind on the frontend. Features multi-provider payments (Paystack, PayPal), real-time socket-based chat, a referral commission system, and a full permissions/team module — built to solve cross-border payments for African merchants.",
    demo: "https://marketverse.store/",
    github: "",
  },
  {
    id: 25,
    image: wale_lab,
    title: "Wale Lab",
    description:
      "The Nexus of Innovation and Real World Applications. Built with PNPM and NestJS (PERN stack). A comprehensive platform for property management, deal tracking, and payment processing for estate developers and marketers, driving Africa's progress through innovative technology solutions.",
    demo: "https://lab.wale.university/",
    github: "",
  },
  {
    id: 24,
    image: mozofy,
    title: "Mozofy - Real Estate OS",
    description:
      "As Full Stack Developer, I built a comprehensive real estate operating system using PERN stack. Developed an all-in-one platform for property management, deal tracking, and payment processing for estate developers and marketers.",
    demo: "https://staging.mozofy.com/",
    github: "",
  },
  {
    id: 23,
    image: henosis,
    title: "Henosis Intl.",
    description:
      "Nonprofit organization empowering vulnerable communities through education, health initiatives, and youth development programs.",
    demo: "https://henosis-intl.netlify.app",
    github: "",
  },
  {
    id: 22,
    image: builditlab,
    title: "BuilditLab",
    description:
      "Software development company helping startups and growing businesses design, build, and launch reliable digital products — from MVPs to enterprise applications that solve real business problems.",
    demo: "https://builditlab.netlify.app",
    github: "",
  },
  {
    id: 21,
    image: abbas,
    title: "Abba's Court Ministries",
    description:
      "Christian fellowship platform built with MERN stack, offering worship resources, event management, and community features for spiritual growth.",
    demo: "https://abbas-court.vercel.app",
    github: "",
  },
  {
    id: 20,
    image: opportuniverse,
    title: "Opportuniverse",
    description:
      "As Full Stack Developer, I built a comprehensive platform for job and scholarship applications. Implemented user authentication, application tracking, and admin dashboards for managing opportunities and candidate submissions.",
    demo: "https://opportuniverse-peze.vercel.app",
    github: "",
  },
  {
    id: 19,
    image: realestate,
    title: "Real Estate Deal Analyzer",
    description:
      "As Full Stack Developer, I created an analytical tool for evaluating property investments. Developed algorithms for ROI calculation, market analysis, and investment scoring to help users make data-driven real estate decisions.",
    demo: "https://real-estate-deal-analyzer-e7l6.vercel.app",
    github: "",
  },
  {
    id: 18,
    image: stabledoc,
    title: "Stablestack (API Docs)",
    description:
      "As Full Stack Developer, I designed and built the API docs using Mintlify, ensuring clear endpoints, code samples, and authentication flows. Documented payment routing, smart accounts, and settlement APIs for seamless developer integration.",
    demo: "https://docs.stablestack.xyz/introduction",
    github: "",
  },
  {
    id: 17,
    image: stablestack,
    title: "Stablestack (Fintech)",
    description:
      "As Full Stack Developer, I built a stablecoin payment router with React/Node. Implemented smart accounts, gasless transactions, and multi-chain settlements. The platform enables instant fiat-to-crypto conversions with compliant KYC/AML checks through our orchestration API.",
    demo: "https://dashboard.stablestack.xyz/",
    github: "",
  },
  {
    id: 16,
    image: outsidelab,
    title: "Outside Innovation Lab",
    description:
      "OutsideLab is a non-profit innovation platform delivering tech and sustainability solutions, plus event space management tools. It connects innovators with resources, fostering collaboration and impact in the tech and sustainability sectors. The platform features a user-friendly interface for managing events, showcasing projects, and facilitating community engagement.",
    demo: "https://outside-lab.netlify.app/",
    github: "",
  },
  {
    id: 15,
    image: mintly,
    title: "Mint NFT Platform",
    description:
      "A comprehensive platform for managing NFTs, built with modern web technologies. The platform allows users to create, view, and manage their NFT collections with an intuitive interface. Features include secure wallet integration, NFT minting functionality, and a marketplace view.",
    demo: "https://nftminting-frontend.vercel.app/",
    github: "https://github.com/Tun95/nftminting",
  },
  {
    id: 14,
    image: edquity,
    title: "Edquity",
    description:
      "Edquity, built with the MERN stack and JavaScript with Google OAuth, empowers communities to report on local education and infrastructure. It offers insights on facilities and resources, amplifying community voices to drive educational improvements through a user-friendly interface.",
    demo: "https://ownit-one.vercel.app/",
    github: "",
  },
  {
    id: 13,
    image: osyr24,
    title: "#OSYR24",
    description:
      "#OSYR24 is a MERN stack web application built with React and TypeScript to support the Ondo State Youth Retreat 2024. It provides event details, schedules, and registration to foster youth engagement in leadership, community development, and growth activities.",
    demo: "https://osyr-24-demo.vercel.app/",
    github: "",
  },
  {
    id: 12,
    image: votersHq,
    title: "VotersHQ",
    description:
      "VotersHq is a platform designed to empower citizens by allowing them to vote on bills and elections. It provides users with access to detailed information on legislative issues and elections, enabling informed decision-making and active participation in the democratic process.",
    demo: "https://voters-hq.vercel.app",
    github: "",
  },
  {
    id: 11,
    image: poqe,
    title: "PoQe Chopz",
    description:
      "This project was built using the MERN stack (MongoDB, Express, React, Node.js). It features a responsive front-end developed with React and a back-end API using Node.js and Express, with MongoDB as the database. Deployed using Vercel for a seamless and fast live experience.",
    demo: "https://poqechopz.vercel.app/",
    github: "",
  },
  {
    id: 10,
    image: mernstore,
    title: "MernStore",
    description:
      "A full-featured e-commerce platform built with the MERN stack (MongoDB, Express.js, React, Node.js). This personal project showcases a complete online shopping experience with user authentication, product browsing, shopping cart functionality, order management, and secure payment processing. The application features a responsive UI with real-time inventory updates, user profile management, order history tracking, and an admin dashboard for product and order management. Built as a demonstration of full-stack development capabilities, MernStore implements best practices in state management, API design, and database modeling.",
    demo: "https://mernstore-app.vercel.app/",
    github: "https://github.com/Tun95/mernstore",
  },
  {
    id: 9,
    image: thriller,
    title: "Thrillers Travel",
    description:
      "Thrillers Travel is a modern travel platform developed using Next.js with TypeScript and Material-UI. As the frontend developer, I focused on creating a seamless user experience, implementing responsive design, and integrating dynamic features that enhance the booking process. Explore the world with an intuitive interface that makes planning your next adventure easy and enjoyable.",
    demo: "https://www.thrillers.travel/",
    github: "",
  },
  {
    id: 8,
    image: shopfinity,
    title: "ShopFinity",
    description:
      "Shopfinity is a versatile ecommerce platform, supporting multiple vendors and currencies. With 6 payment options—PayPal, Paystack, Paytm, Razorpay, Stripe, and Cash on Delivery. To login as admin:\nEmail: shopmate400@gmail.com \nPassword: Shopmate400",
    demo: "https://shopfinity-app.vercel.app/",
    github: "https://github.com/Tun95/shopfinity-app",
  },
  {
    id: 7,
    image: geegpay,
    title: "Geegpay Clone",
    description:
      "The Geegpay Clone is a React-based replica of Geegpay, incorporating MUI icons. This clone replicates Geegpay's functionality while utilizing React's flexibility. With MUI icons, it maintains a consistent design language. It offers a familiar experience while being customizable to suit specific requirements.",
    demo: "https://geegpay-clone.vercel.app/",
    github: "https://github.com/Tun95/geegpay_clone",
  },
  {
    id: 6,
    image: game,
    title: "Game Review Frontend",
    description:
      "Crafted with React and Redux, the Game Review website UI offers gamers an engaging platform to explore insightful game reviews. Its dynamic interface ensures smooth navigation, while Redux efficiently manages the app's state, enhancing user experience and interaction.",
    demo: "https://game-rev-frontend.vercel.app/",
    github: "https://github.com/Tun95/game_rev-frontend",
  },
  {
    id: 5,
    image: gamead,
    title: "Game Review Admin Panel",
    description:
      "The Game Review Admin Panel, powered by React and Redux, delivers comprehensive control over the platform. With intuitive design and state management, it empowers administrators to manage content, user interactions, and data efficiently. Streamlining tasks, it ensures seamless administration for an enriched gaming community.",
    demo: "https://game-rev-admin-pannel.vercel.app/",
    github: "https://github.com/Tun95/game_rev-admin-pannel",
  },
  {
    id: 4,
    image: courier,
    title: "Courier Website Frontend",
    description:
      "The Courier website, crafted using React and Material-UI with dynamic animation libraries, offers a user-friendly interface for seamless package tracking. Combining intuitive design with motion, it enhances the user experience while efficiently managing shipments and deliveries, catering to a modern and efficient courier service.",
    demo: "https://courier-shopmate.vercel.app/",
    github: "https://github.com/Tun95/Courier__Shopmate",
  },
  {
    id: 3,
    image: play,
    title: "PlayONFlix Movie Website",
    description:
      "PlayOnFlix, a React-based movie review platform, delivers an immersive film experience. Seamlessly integrated with trailer viewing, it offers comprehensive reviews, ratings, and insightful comments from users. Engaging UI and smooth interactions redefine how movie enthusiasts explore, critique, and enjoy their favorite films.",
    demo: "https://playon-flix-movie-webapp.vercel.app/",
    github: "https://github.com/Tun95/movie_mern_client",
  },
  {
    id: 2,
    image: shop2,
    title: "Shopmate 2",
    description:
      "ShopMate 2, a React-powered multi-purpose eCommerce platform, revolutionizes online shopping. With its intuitive interface, responsive design, and seamless navigation, users can explore a vast range of products effortlessly. Powered by React, it ensures a dynamic and engaging shopping experience, making ShopMate 2 the ultimate destination for modern online retail",
    demo: "https://shopmate-alpha.vercel.app/",
    github: "https://github.com/Tun95/shopmate-two-app",
  },
  {
    id: 1,
    image: shop,
    title: "Shopmate (1)",
    description:
      "ShopMate, a versatile MERN-based eCommerce platform, redefines online fashion shopping. Seamlessly integrating multiple vendors and offering a wide array of clothing, it provides a comprehensive shopping experience. With PayPal integration, secure transactions are guaranteed, making ShopMate the go-to destination for fashion enthusiasts seeking quality and style.",
    demo: "https://shopmate-one.vercel.app/",
    github: "https://github.com/Tun95/shopmate",
  },
];
